import { IEmailTemplateMetadata } from '@core/types'

export function processEmailTemplate(text: string, metadata: IEmailTemplateMetadata): string {
	for (const key of Object.keys(metadata)) {
		const value = (metadata as never)[key]
		text = text.replace(new RegExp(`{{${key}}}`, 'g'), value)
	}
	return text
}
